// frontend/src/features/bapb/sections/IncomeAssessorAdvancedSection.jsx
import React from "react";
import IncomeAdvanced from "./IncomeAdvanced";

export default function IncomeAssessorAdvancedSection(props) {
  // Advanced Assessor saves under data.income_assessor_advanced
  return <IncomeAdvanced {...props} dataKey="income_assessor_advanced" />;
}
